import { useOrganizationApproved } from "services/organization/useOrganizationApproved";

export const useIsFirstUser = () => {
  const approvedSettings = useOrganizationApproved();

  return !approvedSettings.welcome_completed;
};
